<template>
  <UninstallLayout 
    :title="$t('uninstall.title.thankYouAndGoodbye')"
    responsive
  >
    <template #description>
      <p class="description mt-2">{{ $t('uninstall.lastStep.description') }}</p>
    </template>
    <template #leftContent>
      <div class="uninstall-on-shopify">
        <p class="uninstall-on-shopify__label">{{ $t('uninstall.lastStep.label') }}</p>
        <p class="uninstall-on-shopify__description" v-html="$t('uninstall.lastStep.needUninstall')"></p>
      </div>
      <a :href="shopifyAdminLink">
        <button class="btn btn-primary px-2">{{ $t('generals.goToShopifyAdmin') }}</button>
      </a>
    </template>
    <template #rightContent>
      <img src="../assets/images/go-to-shopify.png" width="588px" height="337px" alt="" />
    </template>
  </UninstallLayout>
</template>

<script>

import { mapState } from "vuex";
import UninstallLayout from "../components/UninstallLayout.vue";

export default {
  name: 'UninstallThankYou',
  components: {
    UninstallLayout,
  },
  computed: {
    ...mapState("account", {
      shopInfo: "shopInfo"
    }),
    shopifyName() {
      return this.shopInfo?.shopifyDomain?.toString().replace('.myshopify.com', '');
    },
    shopifyAdminLink() {
      return `https://admin.shopify.com/store/${this.shopifyName}/settings/apps?tab=installed`
    }
  },
}
</script>

<style scoped lang="scss">

  .uninstall-on-shopify {
    &__label {
      color: $textLightModeHigh;
      font-size: 14px;
      font-weight: 600;
      line-height: 24px;
    }

    &__description {
      color: $dark6;
      font-size: 14px;
      font-weight: 400;
      line-height: 24px;
    }
  }
  .description {
    color: $dark6;
    font-size: 14px;
    font-weight: 400;
    line-height: 24px;
  }
  .btn {
    height: 40px !important;
  }
</style>
